module.exports = __webpack_public_path__ + "static/media/undraw_large-language-models_m4no.759e415b.svg";